
import { Link } from 'react-router-dom';
import { X, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CartButton from './CartButton';
import { useAuth } from '@/hooks/useAuth';

interface MobileMenuProps {
  isOpen: boolean;
  toggleMenu: () => void;
}

const MobileMenu = ({ isOpen, toggleMenu }: MobileMenuProps) => {
  const { user, loading, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      toggleMenu();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const closeMenu = () => toggleMenu();

  if (!isOpen) return null;

  return (
    <div className="absolute top-full left-0 right-0 bg-white shadow-lg border-t z-50 md:hidden">
      <div className="p-4 space-y-4">
        <Link 
          to="/" 
          className="block text-autocare-gray-dark hover:text-autocare-blue transition-colors"
          onClick={closeMenu}
        >
          الرئيسية
        </Link>
        <Link 
          to="/oil-finder" 
          className="block text-autocare-gray-dark hover:text-autocare-blue transition-colors"
          onClick={closeMenu}
        >
          البحث عن الزيت
        </Link>
        <Link 
          to="/oil-request" 
          className="block text-autocare-gray-dark hover:text-autocare-blue transition-colors"
          onClick={closeMenu}
        >
          أطلب زيت سيارتك
        </Link>
        <Link 
          to="/booking" 
          className="block text-autocare-gray-dark hover:text-autocare-blue transition-colors"
          onClick={closeMenu}
        >
          احجز موعدك
        </Link>
        <Link 
          to="/shops" 
          className="block text-autocare-gray-dark hover:text-autocare-blue transition-colors"
          onClick={closeMenu}
        >
          المحلات
        </Link>
        
        <div className="border-t pt-4">
          <div className="flex justify-center mb-4">
            <CartButton />
          </div>
          
          {loading ? (
            <div className="h-9 bg-gray-100 rounded-full animate-pulse"></div>
          ) : user ? (
            <Button 
              variant="ghost" 
              onClick={handleLogout}
              className="w-full rounded-full text-autocare-gray-dark hover:bg-red-50 hover:text-red-600 flex items-center justify-center gap-2"
            >
              <LogOut className="h-4 w-4" />
              تسجيل الخروج
            </Button>
          ) : (
            <div className="space-y-3">
              <Link to="/login" onClick={closeMenu}>
                <Button variant="outline" className="w-full rounded-full border-autocare-blue text-autocare-blue hover:bg-autocare-blue hover:text-white">
                  تسجيل الدخول
                </Button>
              </Link>
              <Link to="/signup" onClick={closeMenu}>
                <Button className="w-full rounded-full bg-autocare-blue text-white hover:bg-autocare-blue-light">
                  إنشاء حساب
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
